export enum CarStatus {
  UNSPECIFIED, // 未知
  CREATED, // 已创建
  ARRIVED, // 已进场
  AUDITING, // 已进入审批
  APPROVED, // 已通过
  REJECTED, // 已驳回
  CANCELED, // 已撤销
  EXITED // 已出厂
}
